import * as React from "react"

import Details from "Catalog/Edit/shared/components/Details"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { IDiscount } from "shared/hubrise/models"

const Delete = ({ discount }: { discount: IDiscount }): JSX.Element => {
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()
  const navigate = useNavigateNoUpdate()

  const handleClick = (): void => {
    navigate(catalogNavigation.editNextPath("discounts"))
    editor.discount.delete(discount.id)
  }

  return <Details.TopbarButton onClick={handleClick} code="delete" />
}

export default Delete
